


















































import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import { mdiChevronLeft } from '@mdi/js'
import { ILinkItem } from '~/assets/interfaces/navigation'

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
  },
})
export default class ComponentCategoryPath extends Vue {
  @Prop({ type: String, default: 'type-1' }) private type!: string
  @Prop({ type: Array, default: () => [] }) private tree!: ILinkItem[]
  @Prop({ type: Array, default: () => [] }) private subCategories!: ILinkItem[]

  // Сколько подкатегорий показать до «Показать все»; 0 — все сразу. В фильтре
  // каталога список длинный и отодвигал сами фильтры вниз.
  @Prop({ type: Number, default: 0 }) private limit!: number

  // Режим фильтра каталога: без цепочки родителей, только один уровень.
  // Есть подкатегории — показываем их. Нет — показываем текущий уровень
  // с выделенным текущим разделом. На последнем уровне бэк кладёт в
  // subCategories соседей без самого раздела, поэтому текущий — последний
  // в tree — ставим первым.
  @Prop({ type: Boolean, default: false }) private levelOnly!: boolean

  // Что лежит в subCategories: соседи текущего раздела (true) или его дети
  // (false). Явный флаг categoryPath.siblings от бэка; пока его нет — null,
  // и мы угадываем по isLastLevel у пунктов (см. isSiblings).
  @Prop({ type: Boolean, default: null }) private siblings!: boolean | null

  private get current() {
    return this.tree.length > 0 ? this.tree[this.tree.length - 1] : null
  }

  private get currentUrl() {
    return this.levelOnly && this.current ? this.current.url : null
  }

  private get isSiblings() {
    if (this.siblings !== null) {
      return this.siblings
    }
    return (
      this.subCategories.length === 0 ||
      this.subCategories.some((item) => item.isLastLevel)
    )
  }

  private get items(): ILinkItem[] {
    if (!this.levelOnly || !this.isSiblings || !this.current) {
      return this.subCategories
    }
    return [this.current, ...this.subCategories]
  }

  private isShowAll = false

  // Другой раздел — список другой, раскрытие к нему не относится.
  @Watch('tree')
  private treeHandler() {
    this.isShowAll = false
  }

  private get hasShowAll() {
    return this.limit > 0 && this.items.length > this.limit
  }

  private get itemsRender() {
    return this.hasShowAll && !this.isShowAll
      ? this.items.slice(0, this.limit)
      : this.items
  }

  private get amountTree() {
    return this.tree.length
  }

  private mdiChevronLeft = mdiChevronLeft
  private mounted(): void {
    this.$emit('loaded')
  }
}
